<template>
  <div class="project-catalog my-3">
    <h1 class="text-center mb-3">Project Catalog</h1>
    <p class="mx-1">
      This project catalog provides a list of common IT projects for inspiration and sharing.
      Select the projects you want to include, and then click "<i>Copy Link</i>" to generate a shareable link with your selection.
    </p>
    <p class="mx-1">You can also use our <a href="/project-quotation-ai">Project Quotation AI</a> chatbot if you prefer. For further questions, don't hesitate to reach out via the <a href="/contact">contact page</a>.</p>
    <div class="mx-1 mt-3">
      <input
        v-model="search"
        type="text"
        class="form-control mb-3"
        placeholder="Search projects..."
      />
    </div>
    <div class="selected-count mb-2 mx-3 d-flex align-items-center justify-content-between">
      <span>{{ selectedProjects.length }} project{{ selectedProjects.length === 1 ? '' : 's' }} selected</span>
      <button class="btn btn-outline-light" @click="copyLink" :disabled="selectedProjects.length === 0">
        Copy Link
      </button>
    </div>
    <ul class="list-group">
      <li
        v-for="(project, idx) in filteredProjects()"
        :key="project.id"
        class="list-group-item catalog-list-item mb-0 py-2 mx-1 pb-0"
        @click="toggleProjectSelection(project.id, $event)"
      >
        <div class="row">
          <div class="col-1 d-flex align-items-center" @click.stop>
            <input type="checkbox"
              :value="project.id"
              v-model="selectedProjects"
              :id="'project-checkbox-' + project.id"
              class="form-check-input"
              @click.stop
            />
          </div>
          <div class="col-10"><h3>{{ project.name }}</h3></div>
        </div>
        <div class="col-12"><p class="description"><i>{{ project.description }}</i></p></div>
        <div v-if="project.tags && project.tags.length" class="col-12 mb-2">
          <span class="badge bg-secondary me-1" v-for="tag in project.tags" :key="tag">{{ tag }}</span>
        </div>
        <hr v-if="idx < filteredProjects().length - 1" class="catalog-divider" />
      </li>
    </ul>
  </div>
</template>

<script>
  import project_catalog from '@/onboarding/catalog.js'

  export default {
    components: {
    },
    data() {
        return {
          search: '',
          projects: project_catalog.project_catalog_items,
          selectedProjects: []
        }
    },
    methods: {
        filteredProjects() {
          // Sort projects by name (case-insensitive)
          const sorted = [...this.projects].sort((a, b) =>
            a.name.toLowerCase().localeCompare(b.name.toLowerCase())
          );
          if (!this.search) {
            return sorted;
          }
          const term = this.search.toLowerCase();
          return sorted.filter(project =>
            project.name.toLowerCase().includes(term) ||
            project.description.toLowerCase().includes(term) ||
            (project.tags && project.tags.some(tag => tag.toLowerCase().includes(term)))
          );
        },
        toggleProjectSelection(projectId, event) {
          // Only toggle if not clicking directly on the checkbox
          if (event.target.tagName === 'INPUT') return;
          const idx = this.selectedProjects.indexOf(projectId);
          if (idx === -1) {
            this.selectedProjects.push(projectId);
          } else {
            this.selectedProjects.splice(idx, 1);
          }
        },
        copyLink() {
          // Build URL with repeated ?projects=... params
          const url = new URL(window.location.href);
          // Remove all existing 'projects' params
          url.searchParams.delete('projects');
          // Add each selected project as a separate param
          this.selectedProjects.forEach(id => {
            url.searchParams.append('projects', id);
          });
          navigator.clipboard.writeText(url.toString()).then(() => {
            // Optionally, show a message (not required)
          });
        }
    },
    created () {
      document.title = 'Project Catalog';
      // On load, check for repeated ?projects= in URL
      const params = new URLSearchParams(window.location.search);
      const validIds = this.projects.map(p => p.id);
      // getAll returns all repeated params
      const projectParams = params.getAll('projects');
      if (projectParams.length > 0) {
        this.selectedProjects = projectParams.filter(id => validIds.includes(id));
      }
    },
    mounted () {
    }
  }
</script>

<style scoped>
  .project-catalog {
    text-align: left;
  }
  .form-check-input {
    background-color: #222;
    border: 1px solid #888;
    width: 1.2em;
    height: 1.2em;
    margin-right: 0.5em;
  }
  .list-group-item.catalog-list-item {
    background-color: rgb(43, 43, 43);
    border: none;
    transition: background-color 0.2s;
  }
  .list-group-item.catalog-list-item:hover {
    background-color: rgb(30, 30, 30);
    cursor: pointer;
  }
  .catalog-divider {
    border: none;
    border-top: 1px solid #fff;
    margin: 0.5rem 0 0 0;
  }
  input.form-control {
    background-color: rgb(43, 43, 43);
    color: #ddd;
    border: none;
    font-size: 18px;
  }
  input.form-control::placeholder {
    color: #aaa;
  }
  .badge {
    font-size: 14px;
    background-color: #444 !important;
    color: #eee;
  }
  h3 {
    color: #fff;
    margin-bottom: 0.5rem;
  }
  .description {
    color: #ccc;
    margin-bottom: 0.5rem;
  }
</style>
